export default __webpack_public_path__ + "static/overu-16efb8e03820b5831d6443b4533073f3.webp";